import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { take, tap } from 'rxjs/operators';

@Component({
    selector: 'odq-bad-browser-page',
    templateUrl: './bad-browser-page.component.html',
    styleUrls: ['./bad-browser-page.component.scss'],
    standalone: false
})
export class BadBrowserPageComponent implements OnInit {

  unsupportedBrowserHtml: string;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.http.get('assets/html/unsupported-browser.html', { responseType: "text" }).pipe(
      take(1),
      tap(html => this.unsupportedBrowserHtml = html)
    ).subscribe();
  }

}
